/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface ShopPerformance
 */
export interface ShopPerformance {
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderAverageNet?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderAverageNetGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderAverageGross?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderAverageGrossGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderProfitNet?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderProfitNetGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderProfitGross?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderProfitGrossGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {string}
     * @memberof ShopPerformance
     */
    currency?: string;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderTurnoverNet?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderTurnoverNetGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderTurnoverGross?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderTurnoverGrossGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderSpendGoodsNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderSpendGoodsGross?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderSpendGoodsNetGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderSpendGoodsGrossGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ShopPerformance
     */
    orderSpendMarketing?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderSpendMarketingGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    orderAmountNet?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    orderAmountGross?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    orderAmountNetGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    orderAmountGrossGranular?: { [key: string]: number; };
}

/**
 * Check if a given object implements the ShopPerformance interface.
 */
export function instanceOfShopPerformance(value: object): value is ShopPerformance {
    return true;
}

export function ShopPerformanceFromJSON(json: any): ShopPerformance {
    return ShopPerformanceFromJSONTyped(json, false);
}

export function ShopPerformanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopPerformance {
    if (json == null) {
        return json;
    }
    return {
        
        'orderAverageNet': json['orderAverageNet'] == null ? undefined : MoneyOutputFromJSON(json['orderAverageNet']),
        'orderAverageNetGranular': json['orderAverageNetGranular'] == null ? undefined : (mapValues(json['orderAverageNetGranular'], MoneyOutputFromJSON)),
        'orderAverageGross': json['orderAverageGross'] == null ? undefined : MoneyOutputFromJSON(json['orderAverageGross']),
        'orderAverageGrossGranular': json['orderAverageGrossGranular'] == null ? undefined : (mapValues(json['orderAverageGrossGranular'], MoneyOutputFromJSON)),
        'orderProfitNet': json['orderProfitNet'] == null ? undefined : MoneyOutputFromJSON(json['orderProfitNet']),
        'orderProfitNetGranular': json['orderProfitNetGranular'] == null ? undefined : (mapValues(json['orderProfitNetGranular'], MoneyOutputFromJSON)),
        'orderProfitGross': json['orderProfitGross'] == null ? undefined : MoneyOutputFromJSON(json['orderProfitGross']),
        'orderProfitGrossGranular': json['orderProfitGrossGranular'] == null ? undefined : (mapValues(json['orderProfitGrossGranular'], MoneyOutputFromJSON)),
        'currency': json['currency'] == null ? undefined : json['currency'],
        'orderTurnoverNet': json['orderTurnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['orderTurnoverNet']),
        'orderTurnoverNetGranular': json['orderTurnoverNetGranular'] == null ? undefined : (mapValues(json['orderTurnoverNetGranular'], MoneyOutputFromJSON)),
        'orderTurnoverGross': json['orderTurnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['orderTurnoverGross']),
        'orderTurnoverGrossGranular': json['orderTurnoverGrossGranular'] == null ? undefined : (mapValues(json['orderTurnoverGrossGranular'], MoneyOutputFromJSON)),
        'orderSpendGoodsNet': json['orderSpendGoodsNet'] == null ? undefined : MoneyOutputFromJSON(json['orderSpendGoodsNet']),
        'orderSpendGoodsGross': json['orderSpendGoodsGross'] == null ? undefined : MoneyOutputFromJSON(json['orderSpendGoodsGross']),
        'orderSpendGoodsNetGranular': json['orderSpendGoodsNetGranular'] == null ? undefined : (mapValues(json['orderSpendGoodsNetGranular'], MoneyOutputFromJSON)),
        'orderSpendGoodsGrossGranular': json['orderSpendGoodsGrossGranular'] == null ? undefined : (mapValues(json['orderSpendGoodsGrossGranular'], MoneyOutputFromJSON)),
        'orderSpendMarketing': json['orderSpendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['orderSpendMarketing']),
        'orderSpendMarketingGranular': json['orderSpendMarketingGranular'] == null ? undefined : (mapValues(json['orderSpendMarketingGranular'], MoneyOutputFromJSON)),
        'orderAmountNet': json['orderAmountNet'] == null ? undefined : json['orderAmountNet'],
        'orderAmountGross': json['orderAmountGross'] == null ? undefined : json['orderAmountGross'],
        'orderAmountNetGranular': json['orderAmountNetGranular'] == null ? undefined : json['orderAmountNetGranular'],
        'orderAmountGrossGranular': json['orderAmountGrossGranular'] == null ? undefined : json['orderAmountGrossGranular'],
    };
}

export function ShopPerformanceToJSON(json: any): ShopPerformance {
    return ShopPerformanceToJSONTyped(json, false);
}

export function ShopPerformanceToJSONTyped(value?: ShopPerformance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderAverageNet': MoneyOutputToJSON(value['orderAverageNet']),
        'orderAverageNetGranular': value['orderAverageNetGranular'] == null ? undefined : (mapValues(value['orderAverageNetGranular'], MoneyOutputToJSON)),
        'orderAverageGross': MoneyOutputToJSON(value['orderAverageGross']),
        'orderAverageGrossGranular': value['orderAverageGrossGranular'] == null ? undefined : (mapValues(value['orderAverageGrossGranular'], MoneyOutputToJSON)),
        'orderProfitNet': MoneyOutputToJSON(value['orderProfitNet']),
        'orderProfitNetGranular': value['orderProfitNetGranular'] == null ? undefined : (mapValues(value['orderProfitNetGranular'], MoneyOutputToJSON)),
        'orderProfitGross': MoneyOutputToJSON(value['orderProfitGross']),
        'orderProfitGrossGranular': value['orderProfitGrossGranular'] == null ? undefined : (mapValues(value['orderProfitGrossGranular'], MoneyOutputToJSON)),
        'currency': value['currency'],
        'orderTurnoverNet': MoneyOutputToJSON(value['orderTurnoverNet']),
        'orderTurnoverNetGranular': value['orderTurnoverNetGranular'] == null ? undefined : (mapValues(value['orderTurnoverNetGranular'], MoneyOutputToJSON)),
        'orderTurnoverGross': MoneyOutputToJSON(value['orderTurnoverGross']),
        'orderTurnoverGrossGranular': value['orderTurnoverGrossGranular'] == null ? undefined : (mapValues(value['orderTurnoverGrossGranular'], MoneyOutputToJSON)),
        'orderSpendGoodsNet': MoneyOutputToJSON(value['orderSpendGoodsNet']),
        'orderSpendGoodsGross': MoneyOutputToJSON(value['orderSpendGoodsGross']),
        'orderSpendGoodsNetGranular': value['orderSpendGoodsNetGranular'] == null ? undefined : (mapValues(value['orderSpendGoodsNetGranular'], MoneyOutputToJSON)),
        'orderSpendGoodsGrossGranular': value['orderSpendGoodsGrossGranular'] == null ? undefined : (mapValues(value['orderSpendGoodsGrossGranular'], MoneyOutputToJSON)),
        'orderSpendMarketing': MoneyOutputToJSON(value['orderSpendMarketing']),
        'orderSpendMarketingGranular': value['orderSpendMarketingGranular'] == null ? undefined : (mapValues(value['orderSpendMarketingGranular'], MoneyOutputToJSON)),
        'orderAmountNet': value['orderAmountNet'],
        'orderAmountGross': value['orderAmountGross'],
        'orderAmountNetGranular': value['orderAmountNetGranular'],
        'orderAmountGrossGranular': value['orderAmountGrossGranular'],
    };
}

